import { Skeleton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ContentCard } from 'shared/components';

interface OfferListLoadingStateProps {
    numberOfActions?: number;
    withStatus?: boolean;
}

export default function OfferListLoadingState(props: OfferListLoadingStateProps) {
    return (
        <Root>
            <JobListItemSkeleton { ...props } />
            <JobListItemSkeleton { ...props } />
            <JobListItemSkeleton { ...props } />
        </Root>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    rowGap: theme.spacing(3)
}));

function JobListItemSkeleton({ numberOfActions, withStatus }: OfferListLoadingStateProps) {
    return (
        <ContentCard>
            <Stack gap={ 2 }>
                <Stack justifyContent="space-between"
                    direction="row"
                >
                    <Skeleton width={ 120 } /> { /* Header */ }
                    { withStatus && <Skeleton width={ 63 } /> } { /* Status */ }
                </Stack>
                <Skeleton width={ 300 } /> { /* Customer */ }
                <Skeleton width={ 300 } /> { /* Location */ }
                <Skeleton height={ 60 } /> { /* Information for candidates */ }
            </Stack>

            { /* Actions */ }
            <Stack direction="row"
                gap={ 4 }
                marginTop={ 4 }
            >
                { Array.from({ length: numberOfActions ?? 2 }).map((_, index) => (
                    <Skeleton key={ index }
                        width={ 80 }
                        height={ 36 } />
                )) }
            </Stack>
        </ContentCard>
    );
}
